<template>
  <Loading v-if="isLoading"/>
  <div class="container" v-else>
    <div class="row">
      <div class="col-12 content">
        <h1 v-if="sendMailStatus !== null && sendMailStatus">{{$t('list_of_items_to_be_downloaded')}}</h1>
        <h1 v-else>{{$t('download_form_title')}}</h1>
        <template v-if="sendMailStatus !== null && sendMailStatus">
          <p class="border-box aligncenter dl-message" v-html="$t('form_download_success',{email: form.email})"></p>
          <AssetsDownloadList :isDownloadForm="true"/>
        </template>
        <p v-else-if="sendMailStatus !== null && !sendMailStatus">{{$t('has_error')}}</p>
        <template v-if="sendMailStatus === null">
          <p v-html="$t('form_download_description')"></p>
          <div class="form-confirmation">
            <p v-if="isEmptyCart" class="mb-5 text-center">{{$t('empty_download_list')}}</p>
            <form id="form" @submit.prevent="sendForm" v-else>
              <dl>
                <dt v-html="$t('form_purpose_of_use')"></dt>
                <dd>
                  <div class="form-check" v-for="(purpose,index) in purpose_use" :key="index">
                    <input class="form-check-input" type="radio" v-model="form.purpose_use" :value="$t(purpose)" checked>
                    <label class="form-check-label">{{$t(purpose)}}</label>
                    <input v-if="index === purpose_use.length - 1" type="text" v-model="form.other_purpose_use">
                  </div>
                </dd>
                <dt>{{$t('company_organization_name')}}</dt>
                <dd><input type="text" v-model="form.company"></dd>
                <dt>{{$t('department')}}</dt>
                <dd><input type="text" v-model="form.department"></dd>
                <dt v-html="$t('applicant')"></dt>
                <dd><input type="text" id="person_in_charge" v-model="form.person_in_charge" required></dd>
                <dt v-html="$t('tel')"></dt>
                <dd><input type="tel" id="phone" v-model="form.phone" required></dd>
                <dt v-html="$t('email')"></dt>
                <dd><input type="email" v-model="form.email" id="email" required><span>{{$t('email_description')}}</span></dd>
                <dt></dt>
                <dd><input type="email" @focusout="checkConfirmEmail" v-model="form.email_confirm" id="email_confirm"></dd>
                <dt>{{$t('the_author_of_the_book')}}</dt>
                <dd><input type="text" v-model="form.purpose_detail1"></dd>
                <dt>{{$t('the_name_of_the_publication')}}</dt>
                <dd><input type="text" v-model="form.purpose_detail2"></dd>
                <dt>{{$t('the_date_of_publication')}}</dt>
                <dd><textarea v-model="form.purpose_detail3"></textarea></dd>
              </dl>
              <div class="dl-btn">
                <router-link :to="{name: 'AssetsDownloadList'}" class="back">{{$t('back')}}</router-link>
                <input type="submit" :value="$t('apply_for_download')" class="send">
              </div>
            </form>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";
import AssetsDownloadList from "./AssetsDownloadList";

export default {
  name: "AssetDownloadForm",
  components: {AssetsDownloadList, Loading},
  mounted() {
    window.history.scrollRestoration = "manual"
    window.scrollTo(0, 0)
  },
  data() {
    return {
      isLoading: false,
      sendMailStatus: null,
      lang: lang,
      purpose_use: [
          'form_purpose_of_use_publication',
          'form_purpose_of_use_printed',
          'form_purpose_of_use_exhibition',
          'form_purpose_of_use_newspaper',
          'form_purpose_of_use_other'
      ],
      form: {
        ids: localStorage.getItem('cart'),
        purpose_use: '',
        other_purpose_use: '',
        company: '',
        department: '',
        person_in_charge: '',
        phone: '',
        email: '',
        email_confirm: '',
        purpose_detail1: '',
        purpose_detail2: '',
        purpose_detail3: '',
      }
    }
  },
  computed: {
    isEmptyCart() {
      if (localStorage.getItem('cart')) return false
      return true
    }
  },
  methods: {
     scrollToId (id) {
         const section = document.querySelector(id);
         if (section) {
             section.scrollIntoView({ behavior: "smooth" });
         }
     },
     isFormValid () {
         if (this.form.person_in_charge === '') {
             return false;
         }
         if (this.form.phone === '') {
             return false;
         }
         if (this.form.email === '') {
             return false;
         }
         if (this.form.email !== this.form.email_confirm) {
             return false;
         }
         return true;
     } ,
    checkConfirmEmail () {
      if(this.form.email !== this.form.email_confirm) {
        alert('メールアドレスが一致しません。');
      }
    },
    sendForm() {
         if (this.isFormValid()){
             this.isLoading = true
             let formData = new FormData()
             formData.append('lang', this.lang)
             formData.append('ids', this.form.ids)
             formData.append('purpose_use', this.form.purpose_use)
             formData.append('other_purpose_use', this.form.other_purpose_use)
             formData.append('company', this.form.company)
             formData.append('department', this.form.department)
             formData.append('person_in_charge', this.form.person_in_charge)
             formData.append('phone', this.form.phone)
             formData.append('email', this.form.email)
             formData.append('purpose_detail1', this.form.purpose_detail1)
             formData.append('purpose_detail2', this.form.purpose_detail2)
             formData.append('purpose_detail3', this.form.purpose_detail3)
             const config = {
                 headers: {
                     'Content-Type': 'multipart/form-data'
                 }
             }
             axios.post('/api/archives/assets-download-registration', formData,config)
                 .then((res) => {
                     this.sendMailStatus = true
                 })
                 .catch(() => {
                     this.sendMailStatus = false
                 })
                 .finally(() => {
                     this.isLoading = false
                 })
         }else{
             this.scrollToId('#form')
             alert('必須項目を入力してください。');
         }
    }
  }
}
</script>

<style scoped>

</style>
